import { ref, computed } from 'vue'

export function usePricing() {
  const priceData = ref({
    netPrice: 0,
    vatAmount: 0,
    totalPrice: 0
  })

  const formatCurrency = (price) => {
    if (!price) return '€0,00'
    return new Intl.NumberFormat('de-DE', {
      style: 'currency',
      currency: 'EUR',
    }).format(price)
  }

  const calculatePriceData = (selectedItem, couponResult = null) => {
    if (!selectedItem) return
    
    // Check if we have a valid free upgrade coupon
    const isFreeUpgradeWithCoupon = couponResult?.success && 
                                   (couponResult.data.coupon.type === 'free_team_pro' || 
                                    couponResult.data.coupon.type === 'free_coins' || 
                                    couponResult.data.coupon.type === 'user_related')
    
    if (isFreeUpgradeWithCoupon) {
      priceData.value = {
        netPrice: 0,
        vatAmount: 0,
        totalPrice: 0
      }
    } else {
      const netPrice = parseFloat(selectedItem.price || selectedItem.teamPlanPrice) / 1.19
      const vatAmount = parseFloat(selectedItem.price || selectedItem.teamPlanPrice) - netPrice
      const totalPrice = parseFloat(selectedItem.price || selectedItem.teamPlanPrice)
      
      priceData.value = {
        netPrice: Math.round(netPrice * 100) / 100,
        vatAmount: Math.round(vatAmount * 100) / 100,
        totalPrice: Math.round(totalPrice * 100) / 100
      }
    }
  }

  const calculateCustomCoinPrice = async (coins) => {
    try {
      const { calculatePrice } = await import('@/api/billing')
      const priceData = await calculatePrice(coins)
      
      return {
        netPrice: parseFloat(priceData.netPrice) || 0,
        vatAmount: parseFloat(priceData.vatAmount) || 0,
        totalPrice: parseFloat(priceData.totalPrice) || 0,
        pricePerCoin: parseFloat(priceData.pricePerCoin) || 0.142
      }
    } catch (error) {
      console.error('Fehler bei der dynamischen Preisberechnung:', error)
      // Fallback to static calculation
      const pricePerCoin = 0.142
      const netPrice = Math.round((coins * pricePerCoin) / 1.19 * 100) / 100
      const vatAmount = Math.round((coins * pricePerCoin - netPrice) * 100) / 100
      const totalPrice = Math.round(coins * pricePerCoin * 100) / 100
      
      return {
        netPrice,
        vatAmount,
        totalPrice,
        pricePerCoin
      }
    }
  }

  return {
    priceData,
    formatCurrency,
    calculatePriceData,
    calculateCustomCoinPrice
  }
}
